<template>
  <v-dialog
    v-model="isOpen"
    max-width="1000"
    scrollable
    content-class="amtzDialog"
  >
    <v-card>
      <v-card-title>{{ debt.name }} Amortization Schedule <v-chip :color="min ? 'secondary' : 'primary'" class="ml-2" x-small label>{{ min ? 'No Plan' : 'WealthyIQ'}}</v-chip></v-card-title>
      <v-card-text class="px-0">
        <v-simple-table v-if="renderTable" dense class="stickyTable">
          <template v-slot:default>
            <thead>
              <tr>
                <th>Date</th>
                <th>Starting Balance</th>
                <th>Interest Paid</th>
                <th>Principal Paid</th>
                <th>Additional Principal</th>
                <th>Total Payment</th>
                <th>End Balance</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="dt in detail"
                :key="'debt-amtz-' + dt.month"
              >
                <td>{{ dt.month }}</td>
                <td class="currency">{{ dt.start_balance | number }}</td>
                <td class="currency">{{ dt.interest | number }}</td>
                <td class="currency">{{ getPrincipal(dt) | number }}</td>
                <td class="currency">{{ getAddlPrincipal(dt) | number }}</td>
                <td class="currency">{{ dt.payment | number }}</td>
                <td class="currency">{{ dt.end_balance | number }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn small color="secondary" @click="close()">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DebtAmtzDialog',
  data() {
    return {
      isOpen: false,
      debt: {},
      min: false,
      renderTable: false
    }
  },
  computed: {
    detail() {
      let orig = (this.min ? this.debt.detail_original : this.debt.detail)
      let data = Object.values(orig)
      data.sort((a, b) => {
        return a.month < b.month
      })
      return data
    },
    minimumPayment() {
      return Math.round(parseFloat(this.debt.minimum_payment) * 100) / 100
    }
  },
  methods: {
    open(debt,min) {
      if(!debt || !debt.detail || !debt.detail_original) return
      this.renderTable = false
      this.debt = debt
      this.min = (min ? true : false)
      this.isOpen = true
      this.renderTable = true
    },
    close() {
      this.isOpen = false
    },
    getPrincipal(dt) {
      if(this.debt.interest_only) {
        let dstart             = this.$moment(this.debt.start_date)
        let dend               = this.$moment(dt.month + '-05')
        let paymentmonth       = dend.diff( dstart, 'months', true ) + 1
        if(paymentmonth <= this.debt.interest_only_months) return 0
      }
      let p = (dt.payment < this.minimumPayment ? dt.payment - dt.interest : this.minimumPayment - dt.interest)
      return (p < 0 ? 0 : p)
    },
    getAddlPrincipal(dt) {
      let p = (dt.payment - dt.interest - this.getPrincipal(dt))
      return (p < 0 ? 0 : p)
    }
  }
}
</script>

<style lang="scss">
  .amtzDialog .stickyTable {
    thead > tr > th{
      position: sticky; 
      top: 0;
    }
  }
</style>